module.exports = __webpack_public_path__ + "img/huaydragon-logo.57262f9d.png";